import { Component } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BorrowerPersonalLoanApplicationService }
from '../../shared/services/borrower-personal-loan-application/borrower-personal-loan-application';
import { BorrowerService } from '../services/borrower/borrower.service';
import { SETTINGS } from '../../clpbp-app.settings';
import { SessionService } from '../services/session/shared/session/session-service/session.service';
import { SessionScenario } from '../services/session/personal-loans/personal-loans-session/personal-loans-session.service';
import { MixpanelService } from '../services/mixpanel.service';

@Component ({
  templateUrl: './login.template.html',
  styleUrls: ['./login.style.css'],
  providers: [BorrowerPersonalLoanApplicationService]
})

export class LoginComponent {
  loginForm: FormGroup;
  loggedIn: boolean;
  sentLogin: boolean;
  error: boolean;

  formOptions = {
    redirectRoutes: ['Finish Agent-Assisted Registration', 'Select Offer page', 'Landing page', 'Apply']
  };

  constructor(
    private authService: AuthService,
    private borrowerService: BorrowerService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private borrowerPLApplicationApi: BorrowerPersonalLoanApplicationService,
    private sessionService: SessionService,
    private mixpanelService: MixpanelService) {

    this.loginForm = new FormGroup({
      'userName': new FormControl(''),
      'password': new FormControl(''),
      'redirect': new FormControl(this.formOptions.redirectRoutes[0])
    });

    this.loggedIn = false;
    this.error = false;
  }

  public login(): void {
    this.sentLogin = true;
    this.error = false;

    this.authService.authenticateCommon(this.loginForm.value.userName, this.loginForm.value.password)
      .subscribe(response => {
        this.loggedIn = true;
        this.sentLogin = false;

        this.borrowerService.getBorrower()
        .subscribe(borrowerData => {
          this.mixpanelService.identify( btoa(this.loginForm.value.userName) );

          const analyticsObj = {
            Definition: 'Login page submit CTA Clicked',
            Product: 'U',
            User: 'B',
            Experience: 'E'
          };
          this.mixpanelService.track('Login Attempted UBE', analyticsObj);

          this.borrowerPLApplicationApi.getPersonalLoanApplication()
            .subscribe(data => {
              let redirectRoute = '';
              const redirectValue = this.loginForm.controls['redirect'].value;

              switch (redirectValue) {
                case 'Finish Agent-Assisted Registration':

                  // TODO Once borrower/GetBorrowerLoanApplicationsStates is finished,
                  // make that call after logging in to determine where to redirect.
                  // For now, assuming a redirect to agent originated scenario if selecting this in dropdown.
                  this.sessionService.personalLoanSession.data.sessionScenario = SessionScenario.AgentOriginated;
                  redirectRoute = '../personal-loans/register';
                  SETTINGS.DEV_ROUTING = true;
                  break;

                case 'Select Offer page':
                  redirectRoute = '../personal-loans/select-offer';
                  SETTINGS.DEV_ROUTING = true;

                  break;

                case 'Landing page':
                  redirectRoute = '../';
                  break;

                case 'Apply':
                  redirectRoute = '../personal-loans/apply';
                  SETTINGS.DEV_ROUTING = true;

                  break;
              }

              this.router.navigate([redirectRoute], { relativeTo: this.activatedRoute });
            }, err => {
              this.error = true;
              console.error(err);
              this.sentLogin = false;
            });
          }, err => {

            this.error = true;
            console.error(err);
            this.sentLogin = false;
          });
        }, err => {
        this.error = true;
        console.error(err);
        this.sentLogin = false;
      }
    );
  }
}
